import { IntlProvider } from 'react-intl';
import { ElibertyThemeProvider } from '@eliberty/design-system-react';
import { render } from '@testing-library/react';

import { getWidgetsConfig } from '~utils';

import messagesDe from '../translations/messages.de';
import messagesEn from '../translations/messages.en';
import messagesFr from '../translations/messages.fr';

export const DEFAULT_LOCALE = 'en';

const messages: Record<string, Record<string, string>> = {
  de: messagesDe,
  en: messagesEn,
  fr: messagesFr,
  'fr-CH': messagesFr,
};

export const getLocale = () => {
  const widgetLocale = getWidgetsConfig('data-locale');
  return widgetLocale && widgetLocale in messages ? widgetLocale : DEFAULT_LOCALE;
};

export const loadTranslations = (locale: string) => {
  const mergedMessages = { ...messages[locale] };
  return mergedMessages;
};

export const renderWithReactIntl = (
  component?: React.ReactNode,
  locale?: string,
  messages?: Record<string, string> | undefined,
) => {
  return render(
    <IntlProvider locale={locale ?? DEFAULT_LOCALE} messages={messages}>
      <ElibertyThemeProvider>{component}</ElibertyThemeProvider>
    </IntlProvider>,
  );
};
